import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "user-menu-container"
};
const _hoisted_2 = {
  class: "avatar-container"
};
const _hoisted_3 = {
  class: "user-title"
};
const _hoisted_4 = {
  class: "user-info-section"
};
const _hoisted_5 = {
  class: "user-name"
};
import { useRouter } from 'vue-router';
import { useUserStore } from '@/stores/userStore';
import { storeToRefs } from 'pinia';
// 默认头像
const defaultAvatar = 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png';
export default /*@__PURE__*/_defineComponent({
  __name: 'UserMenu',
  setup(__props) {
    const router = useRouter();
    const userStore = useUserStore();
    const {
      userInfo
    } = storeToRefs(userStore);
    // 处理菜单项点击
    const handleCommand = command => {
      switch (command) {
        case 'profile':
          router.push('/user/profile');
          break;
        case 'personal':
          router.push('/user/personal');
          break;
        case 'member':
          router.push('/user/member');
          break;
        case 'content':
          router.push('/content');
          break;
        case 'purchased':
          router.push('/user/purchased');
          break;
        case 'learning':
          router.push('/favorite');
          break;
        case 'orders':
          router.push('/user/orders');
          break;
        case 'wallet':
          router.push('/user/wallet');
          break;
        case 'cloud':
          router.push('/user/cloud');
          break;
        case 'messages':
          router.push('/user/messages');
          break;
        case 'lottery':
          router.push('/user/lottery');
          break;
        case 'logout':
          logout();
          break;
      }
    };
    // 退出登录
    const logout = () => {
      userStore.logout();
      router.push('/');
    };
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_ArrowDown = _resolveComponent("ArrowDown");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_divider = _resolveComponent("el-divider");
      const _component_User = _resolveComponent("User");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_Document = _resolveComponent("Document");
      const _component_Reading = _resolveComponent("Reading");
      const _component_SwitchButton = _resolveComponent("SwitchButton");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dropdown, {
        trigger: "click",
        onCommand: handleCommand,
        "popper-class": "custom-user-dropdown"
      }, {
        dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
          class: "user-dropdown-menu"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createVNode(_component_el_avatar, {
            size: 60,
            src: defaultAvatar
          }), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(userInfo)?.username || '未登录'), 1)]), _createVNode(_component_el_divider), _createVNode(_component_el_dropdown_item, {
            command: "personal"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_User)]),
              _: 1
            }), _cache[1] || (_cache[1] = _createElementVNode("span", null, "个人中心", -1))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "content"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Document)]),
              _: 1
            }), _cache[2] || (_cache[2] = _createElementVNode("span", null, "内容管理", -1))]),
            _: 1
          }), _createVNode(_component_el_dropdown_item, {
            command: "learning"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_Reading)]),
              _: 1
            }), _cache[3] || (_cache[3] = _createElementVNode("span", null, "我的收藏", -1))]),
            _: 1
          }), _createVNode(_component_el_divider), _createVNode(_component_el_dropdown_item, {
            command: "logout"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_icon, null, {
              default: _withCtx(() => [_createVNode(_component_SwitchButton)]),
              _: 1
            }), _cache[4] || (_cache[4] = _createElementVNode("span", null, "退出", -1))]),
            _: 1
          })]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_avatar, {
          size: 40,
          src: defaultAvatar
        }), _createElementVNode("span", _hoisted_3, [_cache[0] || (_cache[0] = _createTextVNode(" 用户中心 ")), _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_ArrowDown)]),
          _: 1
        })])])]),
        _: 1
      })]);
    };
  }
});